import * as Yup from 'yup';

export default [
  Yup.object().shape({
    Name: Yup.string().required().max(255).label('Name'),
    Description: Yup.string().max(1000).required().label('Description'),
    AppModel: Yup.object().nullable().required().label('Marketplace App'),
    AppComponents: Yup.array().label('App Components'),
  }),
  Yup.object().shape({
    AppComponents: Yup.array().required().label('App Components'),
  }),
  Yup.object().shape({
    Name: Yup.string().required().max(255).label('Name'),
    Description: Yup.string().max(1000).required().label('Description'),
    AppComponents: Yup.array().required().label('App Components'),
    AppModel: Yup.object().nullable().required().label('Marketplace App'),
  }),
];
